import React from 'react';
import { Link } from 'react-router-dom';
import { NAV_ITEMS, DEMO_PATH } from '../data/site';

export default function Alt6Footer() {
  return (
    <footer className="a6-footer">
      <div className="a6-container">
        <div className="a6-footer-inner">
          <div className="a6-footer-brand">
            <span className="a6-wordmark">
              <span className="a6-wordmark-dot" aria-hidden="true" />
              Asha
            </span>
            <p>
              The AI-native operating system for dental practices. One platform for the
              software your office runs on — and the AI workforce that runs it.
            </p>
          </div>
          <div className="a6-footer-links">
            <div className="a6-footer-col">
              <h4>Product</h4>
              {NAV_ITEMS.slice(0, 3).map((item) => (
                <Link key={item.to} to={item.to}>
                  {item.label}
                </Link>
              ))}
            </div>
            <div className="a6-footer-col">
              <h4>Company</h4>
              <Link to="/alt6/why-asha">Why Asha</Link>
              <Link to="/alt6/switching">Switching to Asha</Link>
              <Link to={DEMO_PATH}>Book a demo</Link>
            </div>
          </div>
        </div>
        <div className="a6-footer-legal">
          <span>© {new Date().getFullYear()} Asha Health. All rights reserved.</span>
          <span>HIPAA-compliant by design.</span>
        </div>
      </div>
    </footer>
  );
}
